import { useMemo } from 'react';
import { classNames } from './style';

export const originVideoLink = (url: string): string => {
  let origin = 'unknow';
  const { hostname } = new URL(url);
  const allow = [
    'youtube',
    'youtu.be',
    'soundcloud',
    'vimeo',
    'dai.ly',
    'dailymotion',
    'facebook',
    'fb',
  ];

  allow.forEach((name) => {
    if (hostname.includes(name)) origin = name.replace('.', '');
  });

  return origin;
};

export type videoFormat = 'square' | 'video' | '4/3' | '3/4' | 'vertical';
export const useClassNameVideoLink = (video: string) =>
  useMemo(() => originVideoLink(video), [video]);

export const classNameModalVideo = (ratio?: videoFormat, rounded = true) =>
  classNames(
    'max-h-[585px] w-11/12 md:w-full overflow-hidden mx-auto',
    rounded && 'rounded-18',
    ratio === 'square' && 'aspect-square',
    ratio === 'video' && 'aspect-video',
    ratio === '4/3' && 'aspect-4/3',
    ratio === '3/4' && 'aspect-3/4',
    ratio === 'vertical' && 'aspect-9/16',
    !ratio && 'aspect-auto',
  );

export const classNamesVideoThumbnail =
  'w-full-important h-full-important h-full w-full aspect-square';

export const configReactPlayer = {
  vimeo: {
    playerOptions: {
      responsive: true,
      title: false,
      byline: false,
      color: '0F6FDE',
    },
  },
};
